import { Button, ConfigProvider, Input, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from './ErrorPage';

const PasswordEmailRequiredPage = ({ error, onSubmit, showHeader = true, errorMessage = '' }) => {
  const [pass, setPass] = useState('');
  const [email, setEmail] = useState('');
  const { t } = useTranslation('Vindoc');

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <ErrorPage
        showHeader={showHeader}
        textBlock={
          <div className="flex flex-col items-center">
            {error ? (
              <div className="mb-2 text-red-600 text-center">
                {errorMessage ? t(errorMessage) : t('Invalid Pass Code')}
              </div>
            ) : (
              <div className="mb-2">{t('Pass Code Required')}</div>
            )}
            <Input
              placeholder={t('Enter Email')}
              type="email"
              onPressEnter={() => onSubmit(email, pass)}
              onChange={(val) => {
                setEmail(val.target.value);
              }}
              className="mb-2 w-52"
              // name="passcode"
              autoComplete="off"
            />
            <input style={{ display: 'none' }} type="password"></input>
            <Input
              placeholder={t('Enter Pass Code')}
              type="password"
              onPressEnter={() => onSubmit(email, pass)}
              onChange={(val) => {
                setPass(val.target.value);
              }}
              className="mb-2 w-52"
              // name="passcode"
              autoComplete="off"
            />
            <Button className="mb-2 flex items-center" onClick={() => onSubmit(email, pass)}>
              {t('Submit')}
            </Button>
          </div>
        }
      />
    </ConfigProvider>
  );
};

export default PasswordEmailRequiredPage;
